module.exports = __webpack_public_path__ + "static/media/md-arrow-down.347a4005.svg";